import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { caseStudies } from '../../mocks/case-studies';

const CaseStudiesPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-navy-900">
        <div className="absolute inset-0 opacity-10">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C9A961' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
        </div>
        <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block px-6 py-2 border border-gold-500 rounded-full mb-6">
              <span className="text-xs font-sans uppercase tracking-widest text-gold-500">BAŞARI HİKAYELERİ</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-6xl text-white mb-6">
              Kanıtlanmış Başarı<br />Kayıtlarımız
            </h1>
            <p className="font-sans text-lg text-white/80 max-w-3xl mx-auto leading-relaxed">
              Müvekkillerimiz için elde ettiğimiz başarılı sonuçlar ve stratejik hukuki çözümlerimiz
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { number: '500+', label: 'Başarılı Dava' },
              { number: '%92', label: 'Başarı Oranı' },
              { number: '2B+', label: 'İşlem Hacmi (USD)' },
              { number: '25+', label: 'Yıllık Deneyim' },
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center p-6 bg-gray-50 rounded-lg"
              >
                <div className="text-5xl font-serif text-gold-500 mb-2">{stat.number}</div>
                <div className="text-sm font-sans uppercase tracking-wider text-gray-600">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="space-y-12">
            {caseStudies.map((caseStudy, index) => (
              <motion.div
                key={caseStudy.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-lg overflow-hidden shadow-lg"
              >
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
                  <div className="lg:col-span-5 relative h-80 lg:h-auto">
                    <img
                      src={caseStudy.image}
                      alt={caseStudy.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-navy-900/60 to-transparent"></div>
                    <div className="absolute top-6 left-6">
                      <span className="px-4 py-2 bg-gold-500 text-white text-xs font-sans font-semibold uppercase tracking-wider rounded-full">
                        {caseStudy.category}
                      </span>
                    </div>
                  </div>
                  <div className="lg:col-span-7 p-8 lg:p-12">
                    <h2 className="font-serif text-3xl text-navy-900 mb-6">{caseStudy.title}</h2>
                    
                    <div className="space-y-6">
                      <div>
                        <h3 className="font-sans text-sm font-semibold uppercase tracking-wider text-gold-500 mb-2">
                          Zorluk
                        </h3>
                        <p className="font-sans text-base text-gray-700 leading-relaxed">
                          {caseStudy.challenge}
                        </p>
                      </div>

                      <div>
                        <h3 className="font-sans text-sm font-semibold uppercase tracking-wider text-gold-500 mb-2">
                          Çözüm
                        </h3>
                        <p className="font-sans text-base text-gray-700 leading-relaxed">
                          {caseStudy.solution}
                        </p>
                      </div>

                      <div>
                        <h3 className="font-sans text-sm font-semibold uppercase tracking-wider text-gold-500 mb-2">
                          Sonuç
                        </h3>
                        <p className="font-sans text-base text-gray-700 leading-relaxed">
                          {caseStudy.outcome}
                        </p>
                      </div>

                      <div className="flex items-center pt-4 border-t border-gray-200">
                        <i className="ri-time-line text-gold-500 mr-2"></i>
                        <span className="font-sans text-sm text-gray-600">
                          <strong>Süre:</strong> {caseStudy.duration}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4">Müvekkil Görüşleri</h2>
            <p className="font-sans text-lg text-gray-600 max-w-2xl mx-auto">
              Müvekkillerimizin deneyimleri ve memnuniyetleri
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              {
                quote: 'Profesyonel yaklaşımları ve derin hukuki bilgileri sayesinde karmaşık davamızı başarıyla sonuçlandırdık. Kesinlikle tavsiye ediyorum.',
                author: 'Mehmet Yıldız',
                position: 'CEO, Yıldız Holding',
              },
              {
                quote: 'Uluslararası yatırım sürecimizde her adımda yanımızda oldular. Güvenilir ve sonuç odaklı bir ekip.',
                author: 'Sarah Johnson',
                position: 'Investment Director, Global Ventures',
              },
              {
                quote: 'Gayrimenkul projemizde karşılaştığımız hukuki sorunları hızlı ve etkili bir şekilde çözdüler. Mükemmel hizmet.',
                author: 'Ali Kaya',
                position: 'Proje Müdürü, İnşaat A.Ş.',
              },
              {
                quote: 'Aile hukuku davamda gösterdikleri hassasiyet ve profesyonellik için çok teşekkür ederim. Kendimi güvende hissettim.',
                author: 'Ayşe Demir',
                position: 'Müvekkil',
              },
            ].map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-50 p-8 rounded-lg"
              >
                <div className="text-4xl text-gold-500 mb-4">"</div>
                <p className="font-sans text-base text-gray-700 leading-relaxed mb-6">
                  {testimonial.quote}
                </p>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gold-500 rounded-full flex items-center justify-center">
                    <span className="text-lg font-sans font-bold text-white">
                      {testimonial.author.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <div className="font-sans text-base font-semibold text-navy-900">{testimonial.author}</div>
                    <div className="font-sans text-sm text-gray-600">{testimonial.position}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-navy-900">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-12 text-center">
          <motion.div {...fadeInUp}>
            <h2 className="font-serif text-4xl lg:text-5xl text-white mb-6">
              Sizin Başarı Hikayenizi Yazalım
            </h2>
            <p className="font-sans text-lg text-white/80 mb-10 max-w-2xl mx-auto">
              Hukuki ihtiyaçlarınız için deneyimli ekibimizle çalışın ve başarılı sonuçlar elde edin
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center px-10 py-5 bg-gold-500 text-white font-sans text-base font-medium rounded-md hover:bg-gold-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Danışmanlık Talep Edin</span>
              <i className="ri-arrow-right-line ml-3"></i>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CaseStudiesPage;